<!--/**
* @author wyr
* @date 2024/12/10 11:15
*/-->
<template>
  <div class="pringMain">
    <div id="printContent" class="pringMain-info">
      <div class="img-box">
        <img :src="url"/>
      </div>
    </div>
    <div class="pringFooter">
      <el-button type="primary" v-print="'#printContent'">打印</el-button>
    </div>
  </div>

</template>
<script>
export default {
  name: "imgDownload",
  data(){
    return{
      url:''
    }
  },
  mounted() {
    if (this.$route.query.url){
      this.url=this.$route.query.url
    }
  }
}
</script>

<style scoped lang="scss">
.pringMain{ position: relative;  width:900px;min-height: calc(100% - 52px); border: 1px solid #ccc; margin:  auto; padding:0 00px 20px !important; font-size: 12px;}
.pringMain-info{margin: 0 00px 20px;width: calc(100% - 00px);padding: 0 60px 20px;box-sizing: border-box;}
.img-box{width: 100%;text-align: center;
  img{display:block;width: 100%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/reimburse/components/imgDownload.vue